import React, { Suspense, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { Autoform } from '../../../components/forms/autoform';
import { Alert, Box, CircularProgress, Container, Grid, Paper } from '@mui/material';
import api from '../../../hooks/useApi';
import { defer, useActionData, useLoaderData, useRevalidator, useSubmit, Await, redirect, useParams } from 'react-router-dom';
import DataContext from '../../../hooks/FormsContext';
import jsonToFormData from '../../../hooks/jsonToFormData';
import ErrorBoundary from '../../../components/errorBoundary';
import PageTitle from '../../../components/PageTitle';

const formName = 'HotelObjDraft'

export async function loader({ request, params }) {
    const id = await params.object_id;
    //const response = await api.get(`/api/HotelObjDraft/${id}/`);
    const response = api.get(`/api/${formName}/${id}/draft/`);
    return defer({
        id: id,
        promise: response,
    })
}

export async function action({ request, params }) {
    const formData = await request.formData();
    const id = params.object_id;
    const actionData = {}
    try {
        const response = await api.put(`/api/form/CopyDraftToClean/${id}/`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
        return redirect(`/mobile/objects`)
        /*actionData.statusText = 'Успішно створено';
        actionData.status = response.status;
    */}
    catch (e) {
        actionData.error = e;
        actionData.status = 'err';
        actionData.statusText = e.message;
    }
    return actionData;
}

export default function MobileObjectDraft() {
    const actionData = useActionData();
    const loaderData = useLoaderData();
    const submit = useSubmit();
    const formHook = useForm();
    const revalidator = useRevalidator();
    const { object_id } = useParams();


    useEffect(() => {
        const handleMessage = (event) => {
            if (event.data.success) {
                revalidator.revalidate();
            }
        };

        window.addEventListener('message', handleMessage);

        return () => {
            window.removeEventListener('message', handleMessage);
        };
    }, [revalidator])

    const handleFormSubmit = (data) => {
        const formData = jsonToFormData(data);
        submit(formData, {
            encType: 'multipart/form-data',
            method: 'post'
        })
    }


    async function formWindow(setLoading) {
        setLoading(true);
        const newWindow = window.open('about:blank', Date.now());
//console.log(('new window created')
        try {
            const id = (await api.get('/api/CreateObjForms/HotelObjChildrenDraft/')).data.id;
            const url = `/mobile/no-nav/new-object/${object_id}/child/draft/${id}/`
            newWindow.location.href = url;
            //console.log('new window updated');
        }
        catch (e) {
            alert("Помилка відкриття нового вікна: ", e);
            newWindow.close();
        }
        finally {
            setLoading(false);
        }
    }


    return (
        <>
            <PageTitle title={`Новий об'єкт (мобільна): ${object_id || loaderData?.id || "ID"}`} />
            <Suspense fallback={
                <Container style={{ display: 'flex', height: '80vh', justifyContent: 'center', alignItems: 'center' }}>
                    <CircularProgress disableShrink />
                </Container>
            }>

                <Await
                    resolve={loaderData.promise}
                    errorElement={<ErrorBoundary />}>
                    {(promise) => {
                        //console.log(promise.data);
                        return (
                            <>
                                <Container>
                                    <Grid item xs={8}>
                                        <Box>
                                            <h2>Додати новий об'єкт</h2>
                                            <DataContext.Provider value={promise.data.forms}>
                                                <Autoform
                                                    fields={promise.data.form}
                                                    formHook={formHook} // Pass the formHook to AutoForm
                                                    formName={formName}
                                                    renderChildForm={true}
                                                    revalidator={revalidator}
                                                    onSubmit={handleFormSubmit}
                                                    patchID={loaderData.id}
                                                    newWindowFunction={formWindow}
                                                    className={'aboba'}
                                                />
                                            </DataContext.Provider>
                                            {actionData && (
                                                <Alert severity='error'>{JSON.stringify(actionData?.error?.response?.data)}</Alert>
                                            )}
                                        </Box>
                                    </Grid>
                                </Container>
                            </>
                        )
                    }}
                </Await>
            </Suspense>
        </>)
}
